import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './declaration.css';
import PopupModel from '../../popup-model/PopupModel'; // Path as provided
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import { checkSubmissionStatus } from '../../../services/candidate/api';

const Declaration = () => {
  const [isAgreed, setIsAgreed] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [submissionResult, setSubmissionResult] = useState(null);
  const navigate = useNavigate();

  const handleCheckboxChange = () => {
    setIsAgreed(!isAgreed);
  };

  const handleSubmit = () => {
    if (isAgreed) {
      setShowConfirmPopup(true);
    }
  };

  const closeConfirmPopup = () => {
    setShowConfirmPopup(false);
  };

  const handleFinalSubmit = async () => {
    try {
      const response = await checkSubmissionStatus();
      setShowConfirmPopup(false); // Close confirmation popup
      if (response.data.success) {
        navigate(`/candidate/candidate-dashboard`);
      } else {
        setSubmissionResult({
          isSuccess: false,
          title: 'Submission Error',
          message: response.message || 'Submission failed. Please complete all required sections.'
        });
      }
      setShowResultPopup(true); // Show result popup
    } catch (error) {
      console.error('Submission failed:', error);
      setShowConfirmPopup(false); // Close confirmation popup
      setSubmissionResult({
        isSuccess: false,
        title: 'Submission Error',
        message: error.response?.data?.message || 'Submission failed. Please try again.'
      });
      setShowResultPopup(true); // Show result popup
    }
  };

  const closeResultPopup = () => {
    setShowResultPopup(false);
    setSubmissionResult(null); // Clear result after closing
  };

  return (
    <>
          <h2 className='decl-header'>Declaration</h2>

    <div className="decl-container">
      <div className="decl-content-area">
        <p className="decl-text">
          This following page is regarding the previous details filled and attachments.
        </p>

        <ul className="decl-list">
          <li>Personal Details</li>
          <li>Address Details</li>
          <li>Education Details</li>
          <li>Employment Details (Not required for freshers)</li>
        </ul>

        <div className="decl-agreement">
          <label className="decl-checkbox-label">
            <input
              type="checkbox"
              checked={isAgreed}
              onChange={handleCheckboxChange}
            />
            <span className="custom-checkbox">
              {isAgreed && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
            </span>
            I agree that all the details and attachments were filled by me.
          </label>
        </div>
      </div>

      <div className="decl-bottom-nav">
        <button className="decl-submit" disabled={!isAgreed} onClick={handleSubmit}>
          Submit <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>

      {showConfirmPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>Confirmation</h3>
            <p>Click OK to Submit the application.</p>
            {/* <p>Select Submit, If you are ready to Submit.</p> */}
            <div className="dec-action-btn">
              <button className="decl-popup-close" onClick={closeConfirmPopup}>Cancel</button>
              <button className="decl-popup-submit" onClick={handleFinalSubmit}>OK</button>
            </div>
          </div>
        </div>
      )}

      <PopupModel
        show={showResultPopup}
        onClose={closeResultPopup}
        title={submissionResult?.title}
        message={submissionResult?.message}
        isSuccess={submissionResult?.isSuccess}
      />
    </div>
    </>
  );
};

export default Declaration;